export const ACTIVATE_EDITOR = 'editor/ACTIVATE_EDITOR'
export const SET_DIAGNOSES = 'editor/SET_DIAGNOSES'
export const SET_CASES = 'editor/SET_CASES'
export const SET_DIAGNOSIS = 'editor/SET_DIAGNOSIS'
export const SET_EDITOR_CASE = 'editor/SET_EDITOR_CASE'
export const SET_CASE_INDEX = 'editor/SET_CASE_INDEX'
export const SET_CASE_VISTS = 'editor/SET_CASE_VISITS'
export const SET_CASE_VISIT = 'editor/SET_CASE_VISIT'
export const SET_DIAGNOSIS_RELIABILITY = 'editor/SET_DIAGNOSIS_RELIABILITY'
export const SET_VTOKEN = 'editor/SET_VTOKEN'
export const SET_COMMENTS = 'editor/SET_COMMENTS'


// WEBPACK FOOTER //
// ./assets/editor/actionTypes.js